import {
  PureComponent,
  ComponentType,
  PropsWithChildren,
  ReactNode,
} from 'react';

import { ConnectIframes } from '../../internal/iframe/connectIframes';
import { ConnectModuleIframeProps } from '../../internal/iframe/connectModuleIframe';
import {
  ConnectModulesRequestProps,
  ConnectModulesStandardProps,
} from '../../internal/modules';
import Connect, { ConnectProps } from '../../main/connect';

import FileEditor, { FileEditorMainProps } from './fileEditor';

export type ConnectFileEditorProps = ConnectModulesRequestProps &
  ConnectModulesStandardProps &
  ConnectModuleIframeProps &
  FileEditorMainProps & {
    defaultComponent?: ComponentType<PropsWithChildren<any>>; // rendered if no fileEditor found
    children?: ReactNode;
  };

export class ConnectFileEditor extends PureComponent<
  ConnectFileEditorProps & ConnectProps
> {
  static defaultProps = {
    width: '100%',
  };
  render() {
    const {
      children,
      width,
      height,
      defaultComponent: DefaultComponent = () => null,
      ...props
    } = this.props;

    return (
      <ConnectIframes {...props} moduleType="fileEditors">
        {iframes => {
          const p = iframes[0];
          if (p) {
            return (
              <FileEditor
                {...props}
                {...p}
                width={width}
                height={height}
                key={p.module.id}
              />
            );
          }
          return <DefaultComponent />;
        }}
      </ConnectIframes>
    );
  }
}

// eslint-disable-next-line import/no-default-export
export default Connect(ConnectFileEditor);
